import React from "react";
import { object } from "prop-types";

import LeftImageRightNews from "../../../../../molecules/LeftImageRightNews";
import NewsWithNoImage from "../../../../../molecules/NewsWithNoImage";
import NewsWithImage from "../../../../../molecules/NewsWithImage";
import FirstStory from "../../../../../molecules/FirstStory";
import SpecialEvent from "../../../SpecialEvent";

import { getStoriesFromCollection } from "../../../../../utils/utils";

import "./center-column.m.css";

const CenterColumn = ({ collection }) => {
  const items = getStoriesFromCollection(collection, 20);

  const stories = items.filter((_, index) => index === 0 || (index >= 4 && index < 6) || (index >= 9 && index < 15));
  let showExcerpt = [0];

  const hasSpecial = collection.items.some(({ type }) => type === "collection");

  if (!hasSpecial) {
    showExcerpt = [0, 1, 2, 6, 7, 8];
  }

  return (
    <div styleName="base">
      <div styleName="container">
        {stories.map((story, index) => {
          const style = { gridArea: `center-${index + 1}` };
          if (index === 0) {
            return (
              <div styleName="first-story" key={index}>
                <FirstStory story={story} />
                <SpecialEvent collection={collection} styleName="special" />
              </div>
            );
          } else if (index > 0 && index < 3) {
            return (
              <LeftImageRightNews
                styleName="center-item"
                styles={style}
                story={story}
                key={index}
                aspectRatio={[1, 2].includes(index) ? [1, 1] : [3, 1]}
                imageType={[1, 2].includes(index) ? "image1x1" : "image3x2"}
                showExcerpt={showExcerpt.includes(index)}
                showCaption={index === 0}
                widths={[180]}
              />
            );
          } else if (index > 2 && index < 6) {
            return (
              <NewsWithImage
                styleName="center-item"
                styles={style}
                story={story}
                key={index}
                showExcerpt={showExcerpt.includes(index)}
                widths={[280]}
              />
            );
          } else {
            return (
              <NewsWithNoImage
                key={index}
                showExcerpt={!hasSpecial}
                story={story}
                styleName="center-item"
                styles={style}
              />
            );
          }
        })}
      </div>
    </div>
  );
};

CenterColumn.propTypes = {
  collection: object,
};

export default CenterColumn;
